/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from './workshop-bookings.ngfactory';
import * as i2 from '../../../app/components/workshop-bookings';
import * as i3 from '@ngrx/store/src/store';
import * as i4 from 'ng2-completer/services/completer-service';
import * as i5 from '@ngrx/effects/src/actions';
import * as i6 from './tutor-allocations.ngfactory';
import * as i7 from '../../../app/components/tutor-allocations';
import * as i8 from '../../../app/reducers/effects/matrix-class';
import * as i9 from '../../../app/services/modal';
import * as i10 from './workshops-timetable-view.ngfactory';
import * as i11 from '../../../app/components/workshops-timetable-view';
import * as i12 from '../../../app/components/workshops-view';
import * as i13 from '@angular/common';
import * as i14 from '@angular/router';
const styles_WorkshopsViewComponent:any[] = ([] as any[]);
export const RenderType_WorkshopsViewComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_WorkshopsViewComponent,data:{}});
function View_WorkshopsViewComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),2,'div',[['class',
      'wv__tab-content timetable']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(1,0,(null as any),(null as any),1,'workshop-bookings',
      ([] as any[]),(null as any),(null as any),(null as any),i1.View_WorkshopBookingsComponent_0,
      i1.RenderType_WorkshopBookingsComponent)),i0.ɵdid(2,245760,(null as any),0,i2.WorkshopBookingsComponent,
      [i3.Store,i4.CompleterService,i5.Actions],(null as any),(null as any))],(_ck,
      _v) => {
    _ck(_v,2,0);
  },(null as any));
}
function View_WorkshopsViewComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),2,'div',[['class',
      'wv__tab-content list']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(1,0,(null as any),(null as any),1,'tutor-allocations',
      ([] as any[]),(null as any),(null as any),(null as any),i6.View_TutorAllocationsComponent_0,
      i6.RenderType_TutorAllocationsComponent)),i0.ɵdid(2,114688,(null as any),0,i7.TutorAllocationsComponent,
      [i3.Store,i8.MatrixClassEffects,i9.ModalService],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,2,0);
      },(null as any));
}
function View_WorkshopsViewComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),2,'div',[['class',
      'wv__tab-content list']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(1,0,(null as any),(null as any),1,'workshops-timetable-view',
      ([] as any[]),(null as any),(null as any),(null as any),i10.View_WorkshopsTimetableViewComponent_0,
      i10.RenderType_WorkshopsTimetableViewComponent)),i0.ɵdid(2,114688,(null as any),
      0,i11.WorkshopsTimetableViewComponent,[i3.Store,i4.CompleterService,i9.ModalService],
      (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,2,0);
  },(null as any));
}
export function View_WorkshopsViewComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),22,'div',[['class',
      'workshop-view']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(1,0,(null as any),(null as any),21,'div',[['class','wv__content-wrapper']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(2,0,(null as any),(null as any),20,'div',[['class','wv__tabbed-container']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(3,0,(null as any),(null as any),12,'ul',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(4,
          0,(null as any),(null as any),3,'li',([] as any[]),(null as any),[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i12.WorkshopsViewComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.clickedTab('bookings')) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(5,278528,(null as any),0,i13.NgClass,
          [i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{ngClass:[0,
              'ngClass']},(null as any)),i0.ɵpod(6,{'active':0}),(_l()(),i0.ɵted(-1,
          (null as any),['Bookings'])),(_l()(),i0.ɵeld(8,0,(null as any),(null as any),
          3,'li',([] as any[]),(null as any),[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i12.WorkshopsViewComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.clickedTab('tutor-allocations')) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(9,278528,(null as any),0,i13.NgClass,
          [i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{ngClass:[0,
              'ngClass']},(null as any)),i0.ɵpod(10,{'active':0}),(_l()(),i0.ɵted(-1,
          (null as any),['Tutor allocations'])),(_l()(),i0.ɵeld(12,0,(null as any),
          (null as any),3,'li',([] as any[]),(null as any),[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:i12.WorkshopsViewComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.clickedTab('timetable')) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(13,278528,(null as any),0,i13.NgClass,
          [i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{ngClass:[0,
              'ngClass']},(null as any)),i0.ɵpod(14,{'active':0}),(_l()(),i0.ɵted(-1,
          (null as any),['Timetable'])),(_l()(),i0.ɵeld(16,0,(null as any),(null as any),
          6,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_WorkshopsViewComponent_1)),i0.ɵdid(18,16384,(null as any),0,i13.NgIf,
          [i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),
          i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_WorkshopsViewComponent_2)),
      i0.ɵdid(20,16384,(null as any),0,i13.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_WorkshopsViewComponent_3)),i0.ɵdid(22,
          16384,(null as any),0,i13.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
              'ngIf']},(null as any))],(_ck,_v) => {
    var _co:i12.WorkshopsViewComponent = _v.component;
    const currVal_0:any = _ck(_v,6,0,_co.isActiveTab('bookings'));
    _ck(_v,5,0,currVal_0);
    const currVal_1:any = _ck(_v,10,0,_co.isActiveTab('tutor-allocations'));
    _ck(_v,9,0,currVal_1);
    const currVal_2:any = _ck(_v,14,0,_co.isActiveTab('timetable'));
    _ck(_v,13,0,currVal_2);
    const currVal_3:any = _co.isActiveTab('bookings');
    _ck(_v,18,0,currVal_3);
    const currVal_4:any = _co.isActiveTab('tutor-allocations');
    _ck(_v,20,0,currVal_4);
    const currVal_5:any = _co.isActiveTab('timetable');
    _ck(_v,22,0,currVal_5);
  },(null as any));
}
export function View_WorkshopsViewComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'workshops-view',
      ([] as any[]),(null as any),(null as any),(null as any),View_WorkshopsViewComponent_0,
      RenderType_WorkshopsViewComponent)),i0.ɵdid(1,114688,(null as any),0,i12.WorkshopsViewComponent,
      [i3.Store,i14.Router,i14.ActivatedRoute],(null as any),(null as any))],(_ck,
      _v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const WorkshopsViewComponentNgFactory:i0.ComponentFactory<i12.WorkshopsViewComponent> = i0.ɵccf('workshops-view',
    i12.WorkshopsViewComponent,View_WorkshopsViewComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/$$_gendir/app/components/workshops-view.ngfactory.ts